import "./index.scss";

export default function CustomizedCheckboxOption(props) {
  const { children, isSelected, selectOption, data } = props;
  return (
    <div
      className={`customized-checkbox-option ${isSelected ? "selected" : ""}`}
      onClick={() => {
        selectOption(data);
      }}
    >
      <div className="customized-checkbox-option__icon">
        {isSelected && <i className="icon-Checkbox-active" />}
        {!isSelected && <i className="icon-Checkbox" />}
      </div>
      <div
        className={`customized-checkbox-option__content ${
          isSelected ? "selected" : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
}
